import { ThemeConstants } from '@getaccept/lib-shared/src/branding/constants/theme.constants';
import * as ColorUtilsHelper from '@getaccept/lib-shared/src/branding/helpers/color-utils.helper';
import type { EntityTheme } from '@getaccept/lib-shared/src/branding/types/theme';
import { openSansV29 } from '@getaccept/lib-shared/src/fonts/font-faces';
import { FontService } from '@getaccept/lib-shared/src/fonts/font-service';
import type { Font } from '@getaccept/lib-shared/src/fonts/types/font';
import { nextTick, useTemplateRef } from 'vue';
import { CssVariables } from '../constants';

export const useFont = () => {
  const editorContainer = useTemplateRef<HTMLDivElement>('editorContainer');

  const loadFont = async (font: Font, cssVariable: string) => {
    FontService.loadFont(font);
    await nextTick();
    editorContainer.value?.style?.setProperty(cssVariable, font.fontFamily);
  };

  const setCustomEditorFontColors = (theme?: EntityTheme) => {
    if (!editorContainer.value) return;

    editorContainer.value?.style.setProperty(
      CssVariables.h1Color,
      theme?.h1Color ?? ThemeConstants.defaultH1Color
    );
    editorContainer.value?.style.setProperty(
      CssVariables.h2Color,
      theme?.h2Color ?? ThemeConstants.defaultH2Color
    );
    editorContainer.value?.style.setProperty(
      CssVariables.textColor,
      theme?.textColor ?? ThemeConstants.defaultTextColor
    );
    const supplementaryColor =
      theme?.supplementaryColor === ThemeConstants.defaultSupplementaryColor
        ? ColorUtilsHelper.lightenColor(theme?.supplementaryColor, 50)
        : theme?.supplementaryColor;
    editorContainer.value?.style.setProperty(
      CssVariables.supplementaryColor,
      supplementaryColor ?? null
    );
  };

  const loadFonts = (theme?: EntityTheme) => {
    const defaultFont = theme?.fontSettings?.defaultFont || openSansV29;
    const headingsFont = theme?.fontSettings?.headingsFont || openSansV29;

    loadFont(defaultFont, CssVariables.defaultFont);
    loadFont(headingsFont, CssVariables.headingsFont);
  };

  return {
    loadFont,
    loadFonts,
    setCustomEditorFontColors,
  };
};
